import {ActionCreator} from 'redux';
import {GetPropertiesOfType} from 'Shared/utilities/GetPropertiesOfType';

export type Action<TAction extends string> = {
  type: TAction;
};

export type ActionWithPayload<TAction extends string, TPayload> = Action<TAction> & {
  payload: TPayload;
  routeParameters: Object[];
};

export type ActionsOf<TActions> = GetPropertiesOfType<TActions, ActionCreator<unknown>>;

export function createAction<T extends string>(type: T): Action<T>;
export function createAction<T extends string, P>(type: T, payload: P, ...routeParameters: Object[]): ActionWithPayload<T, P>;
export function createAction<T extends string, P>(type: T, payload?: P, ...routeParameters: Object[]) {
  return payload ? {type, payload, routeParameters} : {type};
}
